import { cn } from 'library/utils';
import React from 'react';
import { Progress as ProgressReactstrap } from 'reactstrap';
import { Progress as ProgressShadcn } from 'shadcn/components/progress';

/**
 * @param {Object} props
 * @param {number} props.value
 * @param {boolean} props.animated
 * @param {Object} props.style
 * @param {Object} props.barStyle
 * @param {string} props.className
 * @param {Object} props.v2
 * @param {string} props.v2.label
 * @param {number} props.v2.value
 * @param {() => JSX} props.v2.renderValue
 * @param {string} props.v2.classNameContainer
 * @param {string} props.v2.className
 * @param {string} props.v2.classNameIndicator
 * @returns
 */
const Progress = ({ value, animated, style, barStyle, className, children, v2 }) => {
  //! State

  //! Function

  //! Render
  if (v2) {
    return (
      <div className={cn('component:Progress', v2?.classNameContainer)}>
        <div className='tw-flex tw-gap-2 tw-justify-between tw-mb-1'>
          <span>{v2?.label}</span>
          {v2?.renderValue ? v2?.renderValue() : <span>{v2?.value}%</span>}
        </div>
        <ProgressShadcn
          value={v2?.value}
          className={v2?.className}
          classNameIndicator={v2?.classNameIndicator}
        />
      </div>
    );
  }

  return (
    <ProgressReactstrap
      animated={animated}
      style={style}
      barStyle={barStyle}
      className={cn(
        'tw-rounded-full [&_.progress-bar]:tw-bg-primary dark:[&_.progress-bar]:tw-text-black',
        className,
      )}
      value={value}
    >
      {children}
    </ProgressReactstrap>
  );
};

export default Progress;
